import { PaginateQuery } from "core/resources/types/shared";
import { OperacaoEnum } from "resources/enums/conta";
import { RelatorioTenantInfo } from "core/features/relatorios/typings";

export interface CobrancaItem {
  id: string;
  atrasoAcordo?: boolean;
  diasEmAtraso: number;
  pessoa?: PessoaCobranca;
  dataUltimaCobranca: string | null;
  novoContato: string | null;
  responsavel: { id: string; nome: string } | null;
  totalDividas: number;
  blocoQuadra: string;
  numero: string;
  valor: number;

  tipoContatoAcordo?: AcordoTipoContatoEnum | null;
}

export enum AcordoTipoContatoEnum {
  Aplicativo = "sddfsdasd",
  Email = "sdfdgvcvf",
  Ligacao = "smnkfgnvu",
}

export interface PessoaCobranca {
  id: string;
  nome: string;
  imagemUrl?: string | null;
  email?: string;
}

export interface ContasComposicoesAgrupadasResponse {
  categoriaFinanceiraId: string;
  operacao: OperacaoEnum;
  valor: number;
}

export type CobrancaDetailsExportPdfExcelDataType = RelatorioTenantInfo &
  CobrancaDetails & { dataCalculo?: string; nomeUnidade?: string };

export interface CobrancaDetails {
  id: string;
  blocoQuadra: string;
  contas: CobrancaContaDetailsItem[];
  numero: string;
  proprietario?: {
    id: string;
    nome: string;
    email: string;
    telefone: string;
    documento: string;
  };
  locatario?: {
    id: string;
    nome: string;
    email: string;
    telefone: string;
    documento: string;
  };
  pessoas?: {
    dataNascimento: string | null;
    documento: string;
    email: string;
    nome: string;
    telefone: string;
    proprietario: boolean;
    locatario: boolean;
  }[];
}
export interface CobrancaContaItem {
  linkBoleto: string;
  dataVencimento: string;
  id: string;
  descricao: string;
  diasEmAtraso: number;
  juros: number;
  multa: number;
  valorTaxaCobranca: number;
  total: number;
  valor: number;
  taxaMulta: number;
  taxaJuros: number;
  taxaCobranca: number;
  dataPagamento: string | null;
  honorarios: number;
  atualizacaoMonetaria: number;
  valorOriginal: number;
}
export interface CobrancaContaDetailsItem extends CobrancaContaItem {
  origemContaId: OrigemContaEnum;
  composicoes: CobrancaContaItemComposicao[];
  semIndiceMesDataPosicao?: boolean;
}
export interface CobrancaContaItemComposicao {
  id: string;
  nome: string;
  juros: number;
  multa: number;
  valorTaxaCobranca: number;
  total: number;
  valor: number;
  taxaMulta: number;
  taxaJuros: number;
  taxaCobranca: number;
  honorarios: number;
  atualizacaoMonetaria: number;
  valorOriginal: number;
  categoriaFinanceiraId: string;
}

export interface HistoricoCobrancaFindItemResponse {
  id: string;
  observacao: string;
  data: string;
  hora: string;
  unidadeId: string;
  tipoContatoId: string;
  resultadoCobrancaId: string;
  motivoInadimplenciaId: string;
  pessoaResponsavelId: string;
  pessoaResponsavelAgendamento: string | null;
  dataAgendamento: string | null;
  horaAgendamento: string | null;
}
export interface NovoHistoricoCobranca
  extends Omit<HistoricoCobrancaFindItemResponse, "id" | "unidadeId"> {}

export interface CobrancaPessoas {
  id: string;
  nome: string;
  email: string;
  telefone: string;
  documento: string;
  imagemUrl?: string;
}

export interface HistoricoCobrancaItemResponse {
  id: string;
  observacao: string;
  data: string;
  hora: string;
  tipoContato: {
    id: string;
    nome: string;
  };
  motivoInadimplencia: {
    id: string;
    nome: string;
  };
  pessoaResponsavel: {
    id: string;
    nome: string;
  };
  pessoaUsuarioOperador: {
    id: string;
    nome: string;
  };
  resultadoCobranca: {
    id: string;
    nome: string;
  };
  proximoAgendamento: {
    id: string;
    data: string;
    hora: string;
  } | null;
}

export interface AgendaCobrancaItem {
  blocoQuadra: string;
  celular: string;
  hora: string;
  data: string;
  imagemUrl: string | null;
  id: string;
  nome: string;
  observacao: string;
  unidade: string;
  unidadeId: string;
}
export interface AgendaCobrancaQueryParams extends PaginateQuery {
  dataInicio?: string;
  dataFim?: string;
  tipoContatoAcordo?: AcordoTipoContatoEnum | null;
  orderBy?: string;
  orderDirection?: string;
}

export interface FiltroCobranca extends AgendaCobrancaQueryParams {
  pessoasIds?: string[];
  unidadesIds?: string[];
  contasBancariasIds?: string[];
  situacao?: SituacaoEnum;
}

export enum SituacaoEnum {
  Juridico = "juridico",
  Andamento = "andamento",
  ACobrar = "a-cobrar",
  Ajuizada = "ajuizada",
}

export enum OrigemContaEnum {
  Acordo = "71D80920-CD7D-426F-B782-09D6B7DF75F3",
  Arrecadacao = "D6CF75E2-03C4-406E-8501-0C229441E199",
  Reserva = "BCA2119D-0BFB-44FF-BEE3-0CDACE308147",
}
